import type { Action } from 'src/types';

type State = Record<string, boolean>;

const initialState: State = {};

export enum Actions {
  QUERY_FAILURE = 'QUERY_FAILURE',
}

export type LoadingAction = Action<Actions.QUERY_FAILURE> & {
  payload: { queryName: string };
};

export const loadingReducer = (
  state: State = initialState,
  action: LoadingAction,
): State => {
  switch (action.type) {
    case 'QUERY_FAILURE': {
      return {
        ...state,
        [action.payload.queryName]: true,
      };
    }

    default:
      return state;
  }
};
